import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {cloneDeep} from 'lodash';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {configExamTypes, configExamTypesTranslatedConf} from '../../../config/exams';
import {filterExamTypesByDiplomaId} from '@helpers/filtering';
import {setExamEdit} from '@componentDP/js_react/redux/actions/exams';
import {findExamIndex, findExamTypeIndex} from '@helpers/find';
import {withTranslation} from "react-i18next";

class GridEditForm extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(field, value) {
        const {examEdit, setExamEdit} = this.props;
        setExamEdit({...examEdit, [field]: value});
    }
    render() {
        const {handleChange} = this;
        const {exams, examEdit, profileBasic, i18n, t} = this.props;
        const currentLang = i18n.language;
        const configExamTypesFiltered = filterExamTypesByDiplomaId(configExamTypes, profileBasic.diploma_id);
        const examIndex = findExamIndex(exams, examEdit.exam_id);
        const examTypeIndex = findExamTypeIndex(configExamTypesFiltered, examEdit.type);
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Autocomplete
                        id="combo-box-demo"
                        options={exams}
                        getOptionLabel={(option) => {return currentLang === 'en' ? option.name_en : option.name }}
                        noOptionsText={t('no_result')}
                        value={exams[examIndex !== -1 ? examIndex : 0]}
                        onChange={(object, value) => {
                            if (value !== null) {
                                handleChange('exam_id', value.id);
                            }
                        }}
                        renderInput={(params) => {
                            return (
                                <TextField
                                    {...params}
                                    label={t('select_entrance_test')}
                                    size="small"
                                    fullWidth
                                    variant="outlined"/>
                                )
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControl size="small" variant="outlined" fullWidth>
                        <InputLabel id="form" required>{t('select_entrance_test_type')}</InputLabel>
                        <Select
                            label={t('select_entrance_test_type')}
                            value={examTypeIndex !== -1 ? examEdit.type : 0}
                            onChange={(e) => {handleChange('type', e.target.value)}}
                        >
                            <MenuItem value={0}>{t('not_selected')}</MenuItem>
                            {configExamTypesTranslatedConf.map((type) => {
                                return (
                                    <MenuItem value={type.value} key={type.value}>
                                        {t(type.name)}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        type="number"
                        label={t('ball')}
                        inputProps={{step: 0.01}}
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={examEdit.ball}
                        onChange={(e) => {handleChange('ball', e.target.value)}}
                    />
                </Grid>
            </Grid>
        )
    };
}

function mapStateToProps(state) {
    return {
        exams: cloneDeep(state.exams),
        examEdit: cloneDeep(state.examEdit),
        profileBasic: cloneDeep(state.profileBasic),
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setExamEdit,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(GridEditForm));
